import React from "react";
import { Container, Grid, Image, Modal } from "semantic-ui-react";
import cx from "classnames";

import Cancel from "../Buttons/CancelButton";
import SaveChanges from "../Buttons/SaveButton";
import PopUpImage from "images/pop_up.png";

import styles from "./confirmModal.module.scss";

export default function ConfirmModal(props) {
  const { open, setOpen, content, onSave, onCancel, disabled = false } = props;
  return (
    <>
      <Modal
        size="tiny"
        open={props.open}
        centered
        onClose={() => props.setOpen(false)}
        onOpen={() => props.setOpen(true)}
        className={styles.confirmModal}
      >
        <Modal.Content className={cx(styles.content)}>
          <Image size="large" src={PopUpImage} className={cx(styles.image)} />
          <Container className={cx(styles.container)}>
            <Grid>
              <Grid.Row>
                <Grid.Column textAlign="center">
                  <span className={cx(styles.text)}>{props.content}</span>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column textAlign="center">
                  <SaveChanges content="Yes, sure" onClick={props.onSave} disabled={disabled}/>
                  <Cancel content="No, don't" onClick={props.onCancel} disabled={disabled}/>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Container>
        </Modal.Content>
      </Modal>
    </>
  );
}
